<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("rejected tailoring orders") }}
      </h1>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("date range") }}</label>
          <generic-calendar
            type="date"
            :is_range="true"
            ref="generic_calendar"
            @selected="date_changed"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("query") }}</label>
          <div class="control">
            <button class="button is-rounded is-primary" @click="query">
              <span class="icon"><i class="fa fa-bolt"></i></span>
              <span>{{ $t("query") }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="title is-6">{{ $t("rejected orders") }}</div>
    <table class="table is-fullwidth is-striped is-hoverable">
      <thead>
        <tr>
          <th>{{ $t("order number") }}</th>
          <th>{{ $t("customer") }}</th>
          <th>{{ $t("details") }}</th>
          <th>{{ $t("reason") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(order, oidx) in orders" :key="oidx">
          <td>{{ order.order_number }}</td>
          <td>{{ order.name }}</td>
          <td>
            <ul
              v-if="
                order.tailoring_order_items &&
                order.tailoring_order_items.length
              "
            >
              <li
                v-for="(item, iidx) in order.tailoring_order_items"
                :key="iidx"
              >
                {{ item.quantity }} x {{ item.product.name }} @
                {{ format_currency(item.price) }}
              </li>
            </ul>
            <!-- <pre>{{ order.tailoring_order_items }}</pre> -->
          </td>
          <td>
            {{ order.validation_result.reason }}
          </td>
        </tr>
      </tbody>
    </table>
    <!-- <pre>{{ orders }}</pre> -->
  </section>
</template>

<script>
import {
  get,
  generate_datatables_buttons,
  error_message,
  put,
  post,
  del,
  confirm_deletion_dialog,
  success_message,
  format_date_time,
  format_date,
  format_time,
  format_currency,
  change_active_tab,
} from "@/utils";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import { groupBy } from "lodash";

export default {
  name: "SalesReport",
  components: { GenericTable, GenericCalendar },
  data() {
    let v = this;
    return {
      meta: {
        start_date: "",
        end_date: "",
      },
      orders: [],
    };
  },
  computed: {},
  methods: {
    format_date_time,
    format_time,
    format_date,
    format_currency,
    query() {
      let v = this;
      let data = {
        args: v.meta,
        report_uuid: v.$route.params.id,
        method: "qq",
      };
      post("/report/query", data)
        .then((r) => {
          v.orders = r;
        })
        .catch((error) => {
          error_message(error);
        });
    },
    date_changed(date) {
      let v = this;
      v.meta.start_date = date.start_date;
      v.meta.end_date = date.end_date;
    },
  },
  mounted() {
    let v = this;

    // get("/apis/system/users", {})
    //   .then((r) => {
    //     v.users = r;

    //     setTimeout(() => {
    //       // // To access to bulmaCalendar instance of an element
    //       // var element = document.querySelector("#my-element");
    //       // if (element) {
    //       //   // bulmaCalendar instance is available as element.bulmaCalendar
    //       //   element.bulmaCalendar.on("select", function (datepicker) {
    //       //     console.log(datepicker.data.value());
    //       //   });
    //       // }
    //     }, 200);
    //   })
    //   .catch((error) => {
    //     error_message(error);
    //   });
  },
};
</script>

<style>
/* Add Bulma styles here */
</style>
